<template>
  <DBox
    :id="'cmp-distribution-accounts-account_sidewindow-statement_history_list'"
    :addButton="false"
    :addLink="false"
    :rightMenu="[
      {
        text: $t('export'),
        value: 'export',
      },
    ]"
    @menuClick="onRightMenuClick"
  >
    <NTable
      class="dbox1"
      :id="'distribution-accounts-account_sidewindow-statement_history_list'"
      :headers="headers"
      :items="list"
      :config="tableConfig"
      :showNoItems="true"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('statements_history')">
            <span
              @click.stop="(e) => onSelectedStatement(item)"
              class="txtov ut-link ut-text-accent5"
              :title="item['description']"
            >
              {{ item["description"] }}
            </span>
          </td>
          <td v-bind="tdcon('period')">
            <span class="txtov" :title="item['statement_period_txt']">
              {{ item["statement_period_txt"] }}
            </span>
          </td>
          <td v-bind="tdcon('year')">
            <span class="txtov" :title="item['statement_year']">
              {{ item["statement_year"] }}
            </span>
          </td>
          <td v-bind="tdcon('type')">
            <span class="txtov" :title="item['digital_physical']">
              {{ item["digital_physical"] }}
            </span>
          </td>

          <td v-bind="tdcon('country')">
            <span class="txtov" :title="item['fix_country']">
              {{ item["fix_country"] }}
            </span>
          </td>

          <td v-bind="tdcon('invoice')">
            <span :title="item['invoice_ref']" class="txtov">{{
              item["invoice_ref"]
            }}</span>
            <!-- //
            <span class="txtov" :title="item['invoice_date']">
              // {{ item["invoice_date"] }} &nbsp; //
            </span> -->
          </td>
          <td v-bind="tdcon('currency')">
            <span class="txtov" :title="item['currency']">
              {{ item["currency"] }}
            </span>
          </td>
          <td v-bind="tdcon('income')">
            <span class="txtov" :title="item['import_amount']">
              {{ $dft.curr(item["import_amount"]) }}
            </span>
          </td>
          <td v-bind="tdcon('difference')">
            <span class="txtov" :title="item['rounding_difference']">
              {{ $dft.curr(item["rounding_difference"]) }}
            </span>
          </td>
          <td v-bind="tdcon('total')">
            <span class="txtov" :title="item['statement_amount']">
              {{ $dft.curr(item["statement_amount"]) }}
            </span>
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>

<script>
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import TextInput from "../../../../plugins/text-field/text-input";
import { AccountService } from "../../services/account.service";
import FileDownload from "js-file-download";
import { distributionStatementListLDTRoutes } from "../../router/routes";
import { invoiceListLDTRoutes } from "../../../accounting/router/routes";
export default {
  components: {
    NTable,
    TextInput,
  },
  props: ["selectedAccountsDetails"],
  data: function () {
    return {
      selectedInvoice: {},
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
        footer: false,
      }),
    };
  },
  computed: {
    list: function () {
      return this.selectedAccountsDetails?.statements
        ? this.selectedAccountsDetails?.statements.map((s) => {
            s.rounding_difference = s.statement_amount - s.import_amount;
            return s;
          })
        : [] || [];
    },
    headers: function () {
      return [
        createTableHeader("statements_history", { f: 0.7, minw: 200 }),
        createTableHeader("period"),
        createTableHeader("year"),
        createTableHeader("type"),
        createTableHeader("country"),
        createTableHeader("invoice", { f: 0.7, minw: 150 }),
        createTableHeader("currency"),
        createTableHeader("income", { ta: "right" }),
        createTableHeader("difference", { ta: "right" }),
        createTableHeader("total", { ta: "right" }),
      ];
    },
  },
  methods: {
    onRightMenuClick: async function (menu) {
      if (menu == "export") {
        const res = await AccountService.getExportAccountHistory(
          this.selectedAccountsDetails?.account?.account_id
        );
        console.log({ fileURL: res.data });
        FileDownload(res.data, "statement_history.xlsx");
      }
    },
    onSelectedStatement: function (item) {
      this.$router.push({
        name: distributionStatementListLDTRoutes.names.tab,
        params: {
          statement_id: item.statement_id,
          tab: "overview",
        },
      });
    },
    onSelectedInvoice: function (item) {
      this.$router.push({
        name: invoiceListLDTRoutes.names.tab,
        params: {
          invoice_id: item.invoice_id,
          tab: "overview",
        },
      });
    },
  },
};
</script>
